"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var errorMessages = {
  unauthorized: "Either the user was not authenticated or the user's access token has expired.",
  forbidden: {
    "delete": "The user did not have the right permissions to delete this context.",
    get: "The user did not have the right permissions to retrieve this context.",
    update: "The user did not have the right permissions to update this context."
  },
  serviceError: {
    "delete": "Something went wrong while trying to delete the requested context.",
    get: "Something went wrong while trying to retrieve the requested context.",
    update: "Something went wrong while trying to update the requested context."
  },
  notFound: "The context was not found.",
  contactMessage: "Contact UnifiedCimpressNavigation@cimpress.com for more information.",
  ucnIdNotFound: "A UCN contextId was not found in the URL.",
  urlNotValid: "The provided URL was not valid.",
  originUrlNotValid: "The provided origin URL was not valid.",
  destinationUrlNotValid: "The provided destination URL was not valid."
};
var _default = errorMessages;
exports["default"] = _default;